import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'

import { Seo, Layout } from '@/components/generals'

interface Faq {
    question: string
    answer: string
}

const faqs: Faq[] = [
    {
        question: 'دستگاه را مونتاژشده هم تحویل می‌دهید؟',
        answer: 'بله. کیت‌ها به‌صورت قطعات فروخته می‌شوند و اگر بخواهید، دستگاه را پیش از ارسال مونتاژ می‌کنیم.'
    },
    {
        question: 'داخل کیت دستگاه چه چیزهایی هست؟',
        answer: 'همهٔ قطعات مکانیکی شامل پروفیل، صفحه‌ها، پیچ و مهره، لیدسکرو و چرخ‌های V، به‌علاوهٔ موتورهای استپر، درایور، کنترلر، منبع تغذیه و سیم‌کشی.'
    },
    {
        question: 'اسپیندل همراه کیت است؟',
        answer: 'خیر. اسپیندل یا تریمر جزو کیت نیست و در صورت درخواست به سفارش اضافه می‌شود.'
    },
    {
        question: 'ضمانت دستگاه چیست؟',
        answer: 'قطعات مکانیکی (پروفیل، صفحه‌ها، لیدسکرو، چرخ‌ها و اتصالات) یک سال ضمانت کتبی دارند و برای دستگاه‌هایی که از ما خریده‌اید پنج سال خدمات پس از فروش ارائه می‌دهیم.'
    },
    {
        question: 'قطعات الکترونیک هم ضمانت دارند؟',
        answer: 'موتور، درایور، کنترلر و منبع تغذیه ضمانت ندارند و فقط سالم بودنشان هنگام تحویل تضمین می‌شود. قطعهٔ یدکی آن‌ها، همان قطعه یا معادلش، تا دو سال تأمین می‌شود.'
    },
    {
        question: 'برای مشاوره پیش از خرید با چه کسی صحبت کنم؟',
        answer: 'با شماره‌های ۰۹۹۸۱۴۱۴۰۴۰ و ۰۹۹۸۱۴۳۴۰۴۰ تماس بگیرید یا در واتس‌اپ و بله پیام بدهید. فرم بالای همین صفحه هم مستقیم به دست ما می‌رسد.'
    }
]

const logoIds = [
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcd8-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcda-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcdc-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcde-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce0-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce2-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce4-8f2c2147',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce6-8f2c2147'
]

const Contact: FC = (): ReactNode => {
    const [fullName, setFullName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [failed, setFailed] = useState(false)

    const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault()
        setFailed(false)

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    FullName: fullName,
                    email,
                    Phone: phone,
                    Message: message
                })
            })

            if (!response.ok) {
                throw new Error('Request failed')
            }

            setSubmitted(true)
        } catch {
            setFailed(true)
        }
    }

    return (
        <Layout>
            <Seo title='تماس با ما' description='برای مشاورهٔ خرید دستگاه CNC، پروفیل شیاردار و قطعات با OpenBuilds.ir تماس بگیرید: ۰۹۹۸۱۴۱۴۰۴۰، واتس‌اپ و بله.' />

            {/* Hero */}
            <div className='section'>
                <div className='container no-paddings'>
                    <div className='pricing-hero'>
                        <div className='center-title'>
                            <div className='title-holder'>
                                <div className='animate-on-load-01'>
                                    <h1 className='white-title'>با ما در تماس باشید</h1>
                                </div>
                                <div className='animate-on-load-02'>
                                    <div className='experience-paragraph-holder'>
                                        <p>برای سفارش، استعلام قیمت یا مشاورهٔ پیش از خرید پیام بگذارید. <br />تلفن، واتس‌اپ و بله: ۰۹۹۸۱۴۱۴۰۴۰ و ۰۹۹۸۱۴۳۴۰۴۰</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='animate-on-load-03'>
                        <div className='open-roles-cta-holder'>
                            <div className='open-roles-cta-container'>
                                <div className='open-roles-cta'><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                                    <div className='contact-form-block w-form'>
                                        <form id='wf-form-ContactForm' name='wf-form-ContactForm' onSubmit={handleSubmit} style={{ display: submitted ? 'none' : undefined }} className='contact-form'><input className='field-input w-input' maxLength={256} name='FullName' placeholder='نام و نام خانوادگی' aria-label='نام و نام خانوادگی' type='text' id='FullName' value={fullName} onChange={(event) => setFullName(event.target.value)} required /><input className='field-input w-input' maxLength={256} name='email' placeholder='ایمیل' aria-label='ایمیل' type='email' id='email' value={email} onChange={(event) => setEmail(event.target.value)} required /><input className='field-input w-input' maxLength={256} name='Phone' placeholder='شماره موبایل' aria-label='شماره موبایل' type='tel' id='Phone' value={phone} onChange={(event) => setPhone(event.target.value)} required /><textarea id='Message' name='Message' maxLength={5000} placeholder='پیام شما (دستگاه یا قطعهٔ موردنظر، ابعاد و تعداد)' aria-label='پیام شما' value={message} onChange={(event) => setMessage(event.target.value)} required className='field-input textarea w-input' /><input type='submit' className='button w-button' value='ارسال پیام' /></form>
                                        <div className='success-message w-form-done' style={{ display: submitted ? 'block' : 'none' }}>
                                            <div>ممنون! پیامتان رسید و به‌زودی با شما تماس می‌گیریم.</div>
                                        </div>
                                        <div className='error-message w-form-fail' style={{ display: failed ? 'block' : 'none' }}>
                                            <div>متأسفانه پیام ارسال نشد. لطفاً دوباره تلاش کنید یا تماس بگیرید.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='logo-grid-holder'>
                        <div className='w-layout-grid logo-grid'>
                            {logoIds.map((id, index) => (
                                <div key={id} id={id} className='logo-small-container'><img src={`/images/Logo0${index + 1}.svg`} loading='lazy' alt='' className='logo-small' /></div>
                            ))}
                        </div>
                        <div className='fade-in-move-on-scroll'>
                            <p>ساخته‌شده بر پایهٔ طرح‌های متن‌باز OpenBuilds</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <div id='faq' className='section'>
                <div className='container'>
                    <div className='center-title'>
                        <div className='title-holder'>
                            <div className='fade-in-move-on-scroll'>
                                <h2 className='title'>دستگاه، ضمانت و پشتیبانی</h2>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>پاسخ پرسش‌های پرتکرار دربارهٔ کیت دستگاه و خدمات پس از فروش.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='faq-holder'>
                        <div className='faq-container'>
                            {faqs.map((faq) => (
                                <div key={faq.question} className='faq-block'>
                                    <div className='faq-heading'>
                                        <div className='faq-question-text'>{faq.question}</div>
                                        <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                    </div>
                                    <div className='faq-answer-holder'>
                                        <div className='faq-answer'>{faq.answer}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='open-roles-cta-holder'>
                        <div className='open-roles-cta-container'>
                            <div className='open-roles-cta'>
                                <div className='content-holder'>
                                    <h2 className='h3-title'>سؤالتان اینجا نبود؟</h2>
                                    <div className='paragraph-open-roles'>
                                        <p>در واتس‌اپ پیام بدهید تا در اولین فرصت پاسخ بدهیم.</p>
                                    </div>
                                </div>
                                <a href='https://wa.me/989981414040' target='_blank' rel='noreferrer' className='button w-button'>پیام در واتس‌اپ</a><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Contact
